'use strict';

namespace TR {

    interface MonthYearPickerScope extends ng.IScope {
        myp :MonthYearPicker;
    }

    class MonthYear {
        month :number;
        year :number;

        constructor() {
            this.clear();
        }

        public clear() {
            this.month = 0;
            this.year = 0;
        }

        public isNotEmpty() {
            return this.month && this.year && this.month !== 0 && this.year !== 0;
        }
    }

    class MonthYearPicker {

        public my = new MonthYear();

        constructor(private $scope :ng.IScope)
        { }

        public init = (c) => {

            this.$scope.$watch('myp.my', function(val :MonthYear) {
                if (val && val.isNotEmpty()) {
                    c.$setViewValue(angular.copy(val));
                } else {
                    c.$setViewValue(new MonthYear());
                }
            }, true);
        }
    }

    angular
        .module('TR')
        .directive('monthYearPicker', ():ng.IDirective => {

            return {
                scope: {},
                replace: true,
                require: 'ngModel',
                bindToController: {
                    months: '=',
                    years: '=',
                    bookingTrackerPrefix: '@?',
                    enableBookingTracking: '@?'
                },
                controller: MonthYearPicker,
                controllerAs: 'myp',
                templateUrl: (ele, att) => `partials/home/MonthYearPicker?form=${att.enableBookingTracking}`,
                link: function (scope :MonthYearPickerScope,
                                el :ng.IAugmentedJQuery,
                                attr :ng.IAttributes,
                                controller :ng.INgModelController) {
                    scope.myp.init(controller);
                }
            };
        });
}
